const state = {
  currentCart: undefined,
};

export default state;
